"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Print = _ref => {
  let {
    title = 'Print',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 6.656v5.313h-16v-5.313h16zM25.313 18.656q0.563 0 0.969-0.375t0.406-0.938-0.406-0.969-0.969-0.406-0.938 0.406-0.375 0.969 0.375 0.938 0.938 0.375zM21.313 27.969v-6.625h-10.625v6.625h10.625zM25.313 13.344q1.625 0 2.813 1.188t1.188 2.813v8h-5.313v5.313h-16v-5.313h-5.313v-8q0-1.625 1.188-2.813t2.813-1.188h18.625z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Print);
Print.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Print",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Print'",
        "computed": false
      },
      "required": false
    }
  }
};